import React from "react";
import { motion } from "framer-motion";
import Madhack from "../assets/img/MadHack_post.jpg";
import Mechtrogon from "../assets/img/Mechtrogon_post.jpg";
import Parallax from "../assets/img/Parallax_post.jpg";

function Achievements() {
  // const projectContainer = {
  //   hidden: { opacity: 0 },
  //   show: {
  //     opacity: 1,
  //     transition: {
  //       staggerChildren: 0.1,
  //       delayChildren: 0.2,
  //     },
  //   },
  // };
  // const projectAnimation = {
  //   hidden: { opacity: 0, y: 20 },
  //   show: {
  //     opacity: 1,
  //     y: 0,
  //     transition: {
  //       duration: 0.5,
  //     },
  //   },
  // };
  // console.log(projects);
  return (
    <div className="mb-16 lg:mb-18 mt-12 lg:mt-20">
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
        className="text-3xl md:text-5xl font-bold text-my-purple-400 text-center mb-0 lg:mb-8"
      >
        &lt;<span className="text-gray-900 dark:text-white">Achievements</span>
        &#47;&gt;
      </motion.h2>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="container flex justify-center items-top gap-4 flex-wrap pt-10 grid grid-cols-1 md:grid-cols-3"
      >
        <div role="status" class="max-w-sm p-4 border border-my-purple-400 rounded shadow md:p-6 dark:border-gray-800">
          <div class="flex items-center justify-center bg-my-purple-400 rounded dark:bg-gray-800">
              <img
              id="madhack"
              alt="Madhack Finalist"
              src={Madhack}
            />
          </div>
        </div>
        <div role="status" class="max-w-sm p-4 border border-my-purple-400 rounded shadow md:p-6 dark:border-gray-800">
          <div class="flex items-center justify-center bg-my-purple-400 rounded dark:bg-gray-800">
              <img
              id="mechtrogon"
              alt="Mechtrogon Runners Up"
              src={Mechtrogon}
            />
          </div>
        </div>
        <div role="status" class="max-w-sm p-4 border border-my-purple-400 rounded shadow md:p-6 dark:border-gray-800">
          <div class="flex items-center justify-center bg-my-purple-400 rounded dark:bg-gray-800">
              <img
              id="parallax"
              alt="Parallax 2nd Runner Up"
              src={Parallax}
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default Achievements;